module.exports = __webpack_public_path__ + "static/media/vrifikasi_en.fe3c503c.png";